import * as yup from 'yup'
import i18n from '@/localization/i18n'

const t = i18n.global.t

export const businessRequestUrgencySchema = yup.object().shape({
    urgency: yup.string()
        .required(t('w_msg_frmVal_required'))
        .oneOf([
            'g_lst_bizreq_urgency_1_high',
            'g_lst_bizreq_urgency_2_std',
            'g_lst_bizreq_urgency_3_flex'
        ], t('w_msg_frmVal_required')
        )
})